import Layout from '../views/layout/App.vue'
export default {
  path: '/certificate',
  name: 'certificateManage',
  meta: {
    title: '证书管理',
    keepAlive: false
  },
  component: Layout,
  redirect: '/certificate/certificate_list',
  children: [
    {
      path: 'certificate_list',
      name: 'certificateList',
      meta: {
        title: '证书列表',
        keepAlive: false
      },
      component: resolve => require(['@/views/certificateManage/certificateList/index.vue'], resolve),
    },
    {
      path: 'certificate_create',
      name: 'certificateCreate',
      meta: {
        title: '添加证书',
        keepAlive: false,
        pageType: 'create'
      },
      component: resolve => require(['@/views/certificateManage/certificateDetail/index.vue'], resolve),
    },
    {
      path: 'certificate_edit',
      name: 'certificateEdit',
      meta: {
        title: '编辑证书',
        keepAlive: false,
        pageType: 'edit'
      },
      component: resolve => require(['@/views/certificateManage/certificateDetail/index.vue'], resolve),
    },
  ]
}
